import { ItemGroupRecord } from '../types/inventoryItem';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const itemGroupDetailQueryAtom = createQueryAtomFactory(
  'settings.itemGroupDetail',
  (params: { ids: string[] }) => ({
    itemGroups: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        number: true,
        description: true,
        notes: true,
        defaultPricingUnit: true,
        parentId: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): ItemGroupRecord | null => {
      const group = data?.itemGroups?.entries?.[0];
      if (!group) {
        return null;
      }

      return {
        id: group.id,
        name: group.name,
        number: group.number,
        description: group.description ?? '',
        notes: group.notes ?? '',
        defaultPricingUnit: group.defaultPricingUnit ?? null,
        parent: group.parentId ? { id: group.parentId, name: '' } : null,
        timestamps: {
          createdAt: parseZonedDateTime(group.timestamps.createdAt),
          updatedAt: parseZonedDateTime(group.timestamps.updatedAt),
        },
      };
    },
  },
);
